//#region [IMPORT]

// === THIRD-PARTY ===
import { useEffect, useState } from "react";

// === API ===
import { onTaskCancel, removeListener } from "api/prokey/prokey.websocket";

//#endregion

//-----------------------------------------------------------------
export function useTaskCancel() {
  //-----------------------------------------------------------------
  
  //#region [VALUES]

  const [ data , setData ] = useState( { id: null, message: '' } );

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    
    //-----------------------------------------------------------------
    function handleTaskCancel(data) {
      //-----------------------------------------------------------------
      setData( data );
    }

    onTaskCancel( handleTaskCancel );

    return () => {
      removeListener( 'TASK-CANCEL', handleTaskCancel );
    }
  }, [] );

  //#endregion

  return data;
};